import gql from "graphql-tag";

export const GENERATE_UPLOAD_URL = gql`
  query generateSignedUrl(
    $fileName: String!
    $contentType: String!
    $bitsize: Int!
  ) {
    generateSignedUrl(
      fileName: $fileName
      contentType: $contentType
      bitsize: $bitsize
    ) {
      uploadUrl
      finalUrl
      fileId
      validSize
    }
  }
`;

export const GET_GUIA_USO = gql`
  query GetGuiaUsoModulo {
    GetGuiaUsoModulo(id_modulo: 24) {
      id_guia
      titulo
      descripcion
      url_documento
      orden
      id_modulo_fk
    }
  }
`;

export const SIZE_FOLDER = gql`
  query CheckSizeFolder {
    CheckSizeFolder {
      total_contratado {
        bytes
        MB
        GB
      }
      total_usado {
        bytes
        MB
        GB
      }
      total_restante {
        bytes
        MB
        GB
      }
      empresa {
        id_empresa
        nombre_empresa
        nombre_carpeta
      }
    }
  }
`;

export const GET_MD_UPDATES = gql`
  query GetActualizaciones($id_modulo: Int!, $id_tipo: Int!) {
    GetActualizaciones(id_modulo: $id_modulo, id_tipo: $id_tipo) {
      id_actualizacion
      titulo
      descripcion
      url_thumbnail
      fecha_publicacion
      fecha_final
      fecha_creacion
      tipo {
        id_tipo
        nombre_tipo
      }
      modulo {
        id_modulo
        nombre_modulo
        descripcion_modulo
        id_app
        id_admin
        is_web
        tipo_check
      }
      id_estado_fk
      confirm_visto
      contenido {
        id_contenido
        id_actualizacion_fk
        texto
        url_archivo
        nombre_archivo
        orden
        tipo_contenido {
          id_tipo_contenido
          nombre_tipo
        }
      }
    }
  }
`;

export const GET_PROMOCIONES_DASHBOARD = gql`
  query GetPromocionesDashboard($id_modulo: Int!) {
    GetPromocionesDashboard(id_modulo: $id_modulo) {
      id_promocion
      titulo
      promocion
      fecha_inicio
      fecha_termino
      id_modulo_fk
    }
  }
`;

export const BANNER_BODY = `{
    id_file
    tiempo_ejecucion
    fecha_activacion
    total_tiempo
    orden
    archivo {
      id_archivo
      nombre_archivo
      descripcion_archivo
      url_archivo
      tiempo_video
      screenshot_link
      detalle_tipoa {
        id_detalle
        nombre_detalle
        tipo_archivo {
          id_tipo
          nombre_archivo
        }
      }
    }
}`;

export const LIST_BODY = `{
  url_logo
  id_lista
  codigo
  fecha_creacion
  color
  color_tipografia
  layout {
    id_layout
    nombre_layout
  }
  tema {
    id_tema
    nombre_tema
    url_imagen_izq
    url_imagen_der
  }
  videos {
    id_file
    tiempo_ejecucion
    fecha_activacion
    total_tiempo
    orden
    video_tv {
      id_video
      titulo_video
      descripcion_video
      nombre_carpeta
      url_video
      url_imagen
      id_empresa_fk
      id_estado_fk
      alerta_push
      fecha_video
    }
    archivo {
      id_archivo
      nombre_archivo
      descripcion_archivo
      url_archivo
      url_imagen
      tiempo_video
      screenshot_link
      detalle_tipoa {
        id_detalle
        nombre_detalle
        tipo_archivo {
          id_tipo
          nombre_archivo
        }
      }
    }
  }
  banners ${BANNER_BODY}
  banners_horizontales ${BANNER_BODY}
  banners_horizontales_alto ${BANNER_BODY}
  banners_lv_alto_a ${BANNER_BODY}
  banners_lv_alto_b ${BANNER_BODY}
  banners_lv_alto_c ${BANNER_BODY}
  banners_lv_ancho_a ${BANNER_BODY}
  banners_lv_ancho_b ${BANNER_BODY}
  banners_lv_ancho_c ${BANNER_BODY}
  banners_tres_widgets ${BANNER_BODY}
  widgets {
    id_widget
    tipo_widget
    tiempo_ejecucion
    api {
      id_api
      nombre_api
      descripcion_api
      url_mural
      url_api
      indicadores_api {
        id_indicador
        nombre_indicador
        valor
        valor_anterior
        simbolo
        id_tipo_fk
        pais
        fecha_indicador
        id_estado_fk
        fecha_creacion
        fecha_modificacion
      }
      clima_api {
        id_geolocalizacion
        direccion
        latitud
        longitud
        url_formada
      }
      noticia_url {
        id_rrss
        nombre_rrss
        url_api
        id_widget
        id_lista
      }
      noticias {
        id_noticia
        titulo
        fecha
      }
      dias_accidente {
        id_accidente
        dias_accidente
        texto_inicial
      }
      cuenta_regresiva {
        id_cuenta_regresiva
        titulo
        fecha
        hora
      }
      url_imagen
      id_estado_fk
      fecha_creacion
      fecha_modificacion
    }
    modulo {
      id_modulo
      url_imagen
      nombre_modulo
    }
    birthdays {
      id_usuario
      primer_nombre
      apellido_paterno
      fecha_nacimiento
      imagen_perfil
      cargo {
        id_cargo
        nombre_cargo
      }
    }
    nuevo_ingreso {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
      cargo {
        id_cargo
        nombre_cargo
      }
    }
    movimientos {
      fecha_movimiento
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        fecha_ingreso
        cargo {
          id_cargo
          nombre_cargo
        }
      }
      cargo_nuevo {
        id_cargo
        nombre_cargo
      }
      cargo_antiguo {
        id_cargo
        nombre_cargo
      }
    }
    nuevos_padres {
      id_nacimiento
      nombre_bebe
      peso
      medida
      color
      fecha_nacimiento
      sexo {
        id_sexo
        nombre_sexo
      }
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          id_cargo
          nombre_cargo
        }
      }
    }
    reconocimientos {
      id_reconocimiento
      data_completa
      reconocidos {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
      }
      reconocedor {
        id_usuario
        primer_nombre
        apellido_paterno
        apellido_materno
        imagen_perfil
      }
      tipo_reconocimiento {
        id_tipo
        nombre_tipo
        descripcion
        id_estado_fk
      }
      relacion {
        id_relacion
        nombre_relacion
      }
      valor_comportamiento {
        id_valor_comportamiento
        valor {
          id_valor
          nombre_valor
        }
        comportamiento {
          id_comportamiento
          nombre_comportamiento
        }
      }
    }
  }
  widgets_rrss {
    id_widget
    id_rrss
    nombre_rrss
    url_api
    id_lista
  }
  widget_broadcast {
    id_broadcast
    titulo
    texto
    fecha_inicio
    fecha_fin
    color_texto
    color_background
  }
}`;

export const CHANEL_BODY = `
{
      id_canal
      nombre_canal
      cantidad_pantallas
      estado {
        id_estado
        id_estado_real
        nombre_estado
        color
      }
      lista_reproduccion ${LIST_BODY}
    }
`;

export const GET_ONE_CANAL = gql`
  query GetOneCanal($idCanal: Int!) {
    GetOneCanal(id_canal: $idCanal) 
    ${CHANEL_BODY}
  }
`;

export const GET_LAYOUTS_THEMES = gql`
  query GetListaThemes {
    GetListaThemes {
      id_tema
      nombre_tema
      url_imagen_izq
      url_imagen_der
    }
  }
`;

export const GET_LAYOUTS_ACTIONS = gql`
  query GetAccionesLista {
    GetAccionesLista {
      id
      icono
      nombre
      activado
      acciones {
        id
        nombre
        activado
        android
        lg
        samsung
      }
    }
  }
`;

export const GET_LAYOUTS_COLORS = gql`
  query GetListaTipoColores {
    GetListaTipoColores {
      id_tipo
      nombre_tipo
      colores_default
      colores_empresa
    }
  }
`;

export const FIND_ALL_VALORES_COMPORTAMIENTOS = gql`
  query FindAllValoresComportamientos {
    FindAllValoresComportamientos {
      id_valor_comportamiento
      valor {
        id_valor
        nombre_valor
        color
        id_estado_fk
      }
      comportamiento {
        id_comportamiento
        nombre_comportamiento
        id_estado_fk
      }
    }
  }
`;

export const FIND_INDICADORES = gql`
  query FindListaIndicadores {
    FindListaIndicadores {
      id
      titulo
      opciones {
        id_indicador
        nombre_indicador
        nombre_completo
        valor
        simbolo
      }
    }
  }
`;

export const FIND_DATA_EMPRESA_RECONOCIMIENTOS = gql`
  query FindDataEmpresaReconocimientos($id_tipo: Int!) {
    FindDataEmpresaReconocimientos(id_tipo: $id_tipo) {
      reconocimientos {
        id_reconocimiento
        fecha_creacion
        data_completa
        valor_comportamiento {
          id_valor_comportamiento
          valor {
            id_valor
            nombre_valor
          }
          comportamiento {
            id_comportamiento
            nombre_comportamiento
          }
        }
        reconocidos {
          id_usuario
          primer_nombre
          apellido_paterno
          imagen_perfil
          sucursal {
            id_sucursal
            nombre_sucursal
          }
        }
      }
      usuarios_internos {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        sucursal {
          id_sucursal
          nombre_sucursal
        }
      }
    }
  }
`;
